<script setup lang="ts">
const modelValue = defineModel<boolean>({ default: false });

const props = defineProps<{
  text?: string
}>();

function onClick() {
  modelValue.value = !modelValue.value;
}

const { t } = useI18n();
const renderedText = computed(() => {
  if (props.text) return props.text;
  return modelValue.value ? t(`core.common.see_less`) : t(`core.common.see_more`);
});
</script>

<template>
  <button
    class="inline-flex items-center gap-xs text-primary font-semibold"
    type="button"
    @click="onClick"
  >
    <span v-text="renderedText" />
    <Icon
      name="iad-icon:caret-down"
      class="transition origin-center size-3"
      :class="{ 'rotate-180': modelValue }"
    />
  </button>
</template>
